<script lang="ts">
    import ObjectTeaser from './ObjectTeaser.svelte';

    export let objects: ObjectType[];
</script>

{#if objects.length}
    <ul class="divide-y">
        {#each objects as object (object.id)}
            <li>
                <ObjectTeaser {object} />
            </li>
        {/each}
    </ul>
{/if}
